import React from 'react'
import { useTranslation } from 'react-i18next'
import type { MemberBadge } from '@/types/badges'

/** Where a grant came from, in words ("Curso Boas-vindas", "À mão"). */
export const useOriginText = () => {
  const { t } = useTranslation('badges')
  return React.useCallback((grant: Pick<MemberBadge, 'source' | 'origin'> & { sourceRef?: string | null }) => {
    /* F-189: the badge's own "Conceder automaticamente" (`sourceRef: rule:<id>`), not a course's or an event's. */
    if (grant.source === 'rule' && grant.sourceRef?.startsWith('rule:')) return t('origin.autoRule')
    if (grant.origin?.type === 'course') return t('origin.course', { title: grant.origin.title })
    if (grant.origin?.type === 'event') return t('origin.event', { title: grant.origin.title })
    if (grant.origin?.type === 'workflow') return t('origin.workflow', { title: grant.origin.title })
    return t(`source.${grant.source}`, { defaultValue: grant.source })
  }, [t])
}
